import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboAeroportoV2Component } from 'src/app/components/combos/combo-aeroporto-v2/combo-aeroporto-v2.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ComboAeroportoV2Component
  ],
  exports: [
    ComboAeroportoV2Component
  ],
  imports: [
    FormsModule,
    CommonModule
  ]
})
export class ComboAeroportoModule { }
